<template>
  <div class="main-pdf-container">
    <div class="content-date">
      <div
        style="background-color: #6A41BD;
        width: 95px;
        height: 75px;
        display: flex;
        justify-content: center;
        border-radius: 5px;
        "
      >
        <img
          src="../../assets/login-bg.png"
          alt="logo Codet"
          style="width: 75px; height: 75px"
        >
      </div>
      <div class="medical-note">
        <p> {{ $dateString(appointmentDate) }}</p>
      </div>
    </div>
    <div class="table-pdf">
      <el-table
        :data="citas"
        style="width: 100%"
      >
        <el-table-column
          prop="nombrePaciente"
          label="Nombre"
          width="180"
        />
        <el-table-column
          prop="apellidoPaciente"
          label="Apellido"
          width="180"
        />
        <el-table-column
          prop="type"
          label="Tipo de cita"
          width="150"
        />
        <el-table-column
          prop="time"
          label="Hora"
          width="50"
        />
        <el-table-column
          prop="date"
          label="Fecha"
          width="100"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    citas: {
      type: Array,
    },
    appointmentDate: {
      type: String,
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
.main-pdf-container {
  display: flex;
  flex-direction: column;
}
.content-date {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top:10px;
  margin-left: 10px;

  .medical-note {
    margin-right: 25px;
  }
}
.table-pdf {
  margin: 0 auto;
  table {
    margin-top: 10px;
    font-size: 10px;
    tr {
      color: #000;
    }
  }
}
</style>
